import Vue from 'vue';
import App from './App.vue';
import router from './router';
import jQuery from 'jquery';

window.jQuery = window.$ = jQuery;

const app = new Vue({
    data: { loading: false },
    router,

    render: h => h(App),
}).$mount('#app')

router.beforeResolve((to, from, next) => {
    app.loading = true
      next()
  })
  
  router.afterEach(() => {
    app.loading = false
  })


